<!--
  One row per spendable endpoint. The trailing count column is drawn only when
  the caller supplies a wallet — with no `credits` bound this is a price list,
  with one it is an answer to "what does that buy me".
-->
<div class="vcc__row" *ngFor="let action of actions">
  <span class="vcc__icon-wrap">
    <mat-icon class="material-icons-outlined vcc__icon">{{ iconFor(action) }}</mat-icon>
  </span>

  <span class="vcc__body">
    <span class="vcc__label">
      {{ action.label }}
      <!-- Which tasked shape reaches this endpoint, on the row itself. Only the
           unfiltered catalogue asks for it: there the two refresh rows sit next
           to each other at the same price and read as a duplicate. The tag is
           no longer what tells them apart, though — `nearby` dropped its target
           because the entry prices an ENDPOINT rather than a gesture, and
           /v1/vessels/nearby is shaped for a second caller, a search around a
           vessel the user selects, which is build steps 4-8 of the nearby-vessel
           plan and is NOT wired up yet. So `refresh`/AOI is the one tagged entry
           left and the two rows are separated by their descriptions instead.
           That one tag is still drawn: the only caller that sets the flag
           (`hasTargetVariants`) asks whether ANY entry carries a target, so it
           turns the column on for that row alone. Two tags appear only on a
           document that still carries a per-shape tag on both — the LIVE
           operator document until the migration re-syncs it, task snapshots
           taken before the rename, and ee-admin edits. A screen that already
           filtered to one shape would be labelling the only option it shows. -->
      <b class="vcc__tag" *ngIf="showTargets && targetLabel(action)">
        {{ targetLabel(action) }}
      </b>
    </span>
    <span class="vcc__desc" *ngIf="action.description">{{ action.description }}</span>
    <span class="vcc__cost">
      <b class="vcc__credit">{{ creditsLabel(action.credits) }}</b>
      <ng-container *ngIf="showPricing"> · {{ actionCostLabel(action) }}</ng-container>
    </span>
  </span>

  <!-- The answer sits on the same row as the action it answers. The em-dash
       holds the column's width, so a wallet appearing shifts nothing. -->
  <span class="vcc__count" *ngIf="credits !== null" [class.is-on]="showCounts">
    <ng-container *ngIf="showCounts; else noCount">
      {{ formatCredits(unitsAffordable(action)) }}<i>&times;</i>
    </ng-container>
    <ng-template #noCount>—</ng-template>
  </span>
</div>
